let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2eA6y")).then(() => parcelRequire('4gt09'));